import { useCallback, useState } from 'react';
import { useGetBookingRangeMutation } from '@services/member/apartment/apartment.endpoints';
import { useEffect } from 'react';
import { BookingRange } from '@services/member/booking/booking.types';
import moment from 'moment';

export const usePlanningCalendarVM = ({ apartmentId }: { apartmentId: string | number }) => {

    const [fetchBookingRange, { isLoading: isLoadingBookingRange, isError: isFetchingBookingRangeError, error: fetchBookingRangeError, isSuccess: isFetchingBookingRangeSuccess, data: fetchBookingRangeResponse }] = useGetBookingRangeMutation();
    const [bookingRange, setBookingRange] = useState<BookingRange[]>([]);
    const [currentRange, setCurrentRange] = useState<{ start: string, end: string } | null>(null);

    const fetch = useCallback((start: string, end: string) => {
        if (!apartmentId) return;
        setCurrentRange({ start, end: moment(end).subtract(1, 'month').format('YYYY-MM-DD') });
        fetchBookingRange({ id: apartmentId.toString(), start: start, end: end });
    }, [fetchBookingRange, apartmentId]);

    useEffect(() => {
        const start = moment().startOf('month').format('YYYY-MM-DD');
        const end = moment().startOf('month').add(2, 'month').format('YYYY-MM-DD');
        fetch(start, end);
    }, [fetch, apartmentId]);
        
    useEffect(() => {
        if (isLoadingBookingRange) return;
        if (fetchBookingRangeError) return;

        if (isFetchingBookingRangeSuccess && fetchBookingRangeResponse) {
            setBookingRange(fetchBookingRangeResponse.data);
        }
    }, [isLoadingBookingRange, isFetchingBookingRangeError, fetchBookingRangeError, fetchBookingRangeResponse, isFetchingBookingRangeSuccess]);

    const onShownDateChange = (date: Date) => {
        const start = moment(date).startOf('month').format('YYYY-MM-DD');
        const end = moment(date).startOf('month').add(2, 'month').format('YYYY-MM-DD');
        fetch(start, end);
    }
    
    return {
        bookingRange,
        onShownDateChange,
        currentRange,
        isLoadingBookingRange,
    };
};
